import React from "react";
import { useNavigate } from "react-router-dom";

const Title: React.FC<ITitleProps> = ({
  baseTitle,
  basePath,
  activeTitle,
  title,
  subtitle,
  iconTitle,
}) => {
  const navigate = useNavigate();

  const breadcrumb = (
    <ol className="breadcrumb app-page-title__breadcrumb mb-0">
      <li className="breadcrumb-item">
        <a style={{ cursor: "pointer" }} onClick={() => navigate("/")}>
          Inicio
        </a>
      </li>
      <li className="breadcrumb-item">
        <a style={{ cursor: "pointer" }} onClick={() => navigate(basePath)}>
          {baseTitle}
        </a>
      </li>
      {activeTitle && (
        <li className="breadcrumb-item active" aria-current="page">
          {activeTitle}
        </li>
      )}
    </ol>
  );

  return (
    <div className="app-page-title">
      <div className="app-page-title__bar">
        <div
          className={
            subtitle
              ? "app-page-title__main"
              : "app-page-title__main app-page-title__main--solo"
          }
        >
          <button
            type="button"
            className="app-page-title__back"
            onClick={() => navigate(-1)}
            aria-label="Regresar"
          >
            <i className="fa fa-arrow-left" aria-hidden />
          </button>

          <div
            className={
              subtitle
                ? "app-page-title__content"
                : "app-page-title__content app-page-title__content--solo"
            }
          >
            <h1 className="app-page-title__title">
              {title}
              {iconTitle ? <> {iconTitle}</> : null}
            </h1>
            {subtitle ? (
              <p className="app-page-title__subtitle">{subtitle}</p>
            ) : null}
          </div>
        </div>

        <nav className="app-page-title__nav" aria-label="Ruta de navegación">
          {breadcrumb}
        </nav>
      </div>
    </div>
  );
};

export default Title;

interface ITitleProps {
  baseTitle: string;
  basePath: string;
  activeTitle?: string;
  title: string;
  subtitle?: string;
  iconTitle?: React.ReactNode;
}
